module.exports = "/packs/images/home/usb-c924c764ce1611809d2f0ca982907ef0.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/home/usb.png
// module id = 1823
// module chunks = 0